import api from "api/api";
import { RowEmpresaProps } from "components/atendimentos-components/attendance-filter/types";
import { DropdownOptionProps } from "components/dropdown";
import { Toast } from "components/toast";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect, useState } from "react";
import { isUserGerente } from "utils/is-gerente";

export function useFilterEmpresa({
  onChange,
  initialValue
}: {
  onChange: (param: number | undefined) => void;
  initialValue?: number;
}) {
  const [empresas, setEmpresas] = useState<DropdownOptionProps[]>([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState<number | undefined>(
    initialValue
  );
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const { user } = useApplicationContext();

  const isGerente = isUserGerente(user);

  const loadEmpresas = async () => {
    setLoadingEmpresas(true);
    try {
      const { data } = await api.get<RowEmpresaProps[]>(`/customers`);
      setEmpresas([
        ...data.map(({ id, name, codigoNova }) => {
          if (user.userData.type === "PARCEIRO_GERENTE_VAREJO") {
            return { name: name, value: id };
          }
          return { name: `${codigoNova} - ${name}`, value: id };
        })
      ]);
    } catch (e) {
      Toast({ title: "Erro ao carregar empresas", status: "error" });
    } finally {
      setLoadingEmpresas(false);
    }
  };

  useEffect(() => {
    if (isGerente) loadEmpresas();
  }, []);

  const onChangeEmpresa = (value: number | undefined) => {
    setSelectedEmpresa(value);
    onChange(value);
  };

  return { onChangeEmpresa, empresas, loadingEmpresas, selectedEmpresa };
}
